import AthleticsBold from '@assets/Athletics Cuemath/Athletics Bold/Athletics-Bold.otf';

export async function loadFonts() {
  const fonts = [
    new FontFace('Athletics-Bold', `url(${AthleticsBold}) format('opentype')`, {
      weight: '28.8',
    }),
  ];
  await Promise.all(fonts.map(font => font.load()));
  fonts.forEach(font => document.fonts.add(font));
}
